import type { FaireProductEntity } from "../../entity_types/product";

export const p_4ghhcmvxtn: FaireProductEntity = {
  token: "p_4ghhcmvxtn",
  type: "product",
  name: "Thank You...You Are As Sweet As Can Bee!",
  brandToken: "b_cjayhkab",
  brandName: "Just Bee & Me Greeting Cards",
  imageUrl:
    "https://cdn.faire.com/fastly/32788c259c46b542f400f105e8a3f0762766008339ab52842926579e3b06740c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3611c86b735f5433b313b78e7845dbc663317b3cdf52156959e1cda9cd7a22ea.jpeg",
  ],
  priceDollars: 2.5,
  description:
    "4 5/8” x 6 1/4”, Printed on recycled paper, in a protective, biodegradable sleeve & blank inside for freedom of expression!\n\nEach card comes with a recycled paper envelope.\n\n𝗗𝗲𝘁𝗮𝗶𝗹𝘀\n• Made in United States • Dimensions: 11.7 x 16 cm (4.6 x 6.3 in)",
  tags: [],
  msrpDollars: 5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:24.061Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
